<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo de Categoria - Ver</strong>
          </CCardHeader>
          <CCardBody>
            <b-form id="Form">
              <b-row>
                <b-col md="3"></b-col>
               <b-col md="2">
                  <b-form-group label="Codigo:">
                    <b-form-input
                      disabled
                      type="text"
                      ref="code"
                      v-model="product.code"
                    ></b-form-input>
                    <small v-if="errors.code" class="form-text text-danger"
                      >Ingrese un código</small
                    >
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Categoria :" label-for="input-1">
                    <select
                      disabled
                      ref="id_category"
                      v-model="product.id_category"
                      class="form-control"
                    >
                      <option value="">-- Seleccione --</option>
                      <option
                        v-for="item of categories"
                        :key="item.id_category"
                        :value="item.id_category"
                      >
                        {{ item.name }}
                      </option>
                      
                    </select>
                    <small v-if="errors.id_category" class="form-text text-danger"
                      >Seleccione una categoria</small
                    >
                  </b-form-group>
                </b-col>
                 
                <b-col md="3"></b-col>


                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-form-group label="Nombre:">
                    <b-form-input
                      type="text"
                      disabled
                      ref="name"
                      v-model="product.name"
                    ></b-form-input>
                    <small v-if="errors.name" class="form-text text-danger"
                      >Ingrese un nombre</small
                    >
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>

                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-form-group label="Nombre Corto:">
                    <b-form-input
                      type="text"
                      disabled
                      ref="short_name"
                      v-model="product.short_name"
                    ></b-form-input>
                    <small v-if="errors.short_name" class="form-text text-danger"
                      >Ingrese un nombre corto</small
                    >
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>


                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-form-group label="Descripción:">
                    <b-form-input
                      type="text"
                      disabled
                      ref="description"
                      v-model="product.description"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>


                <b-col md="3"></b-col>
                <b-col md="3">
                  <b-form-group label="Tipo de existencia :" label-for="input-1">
                    <select disabled
                      ref="existence_type"
                      v-model="product.existence_type"
                      class="form-control"
                    >
                      <option value="01">MERCADERÍAS</option>
                      <option value="99">OTROS</option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Unidad de Medida :" label-for="input-1">
                    <select
                      disabled
                      ref="unit_measure"
                      v-model="product.unit_measure"
                      class="form-control"
                    >              
                      <option value="NIU">UNIDAD (BIENES)</option>
                      <option value="ZZ">UNIDAD (SERVICIOS) </option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>


                <b-col md="3"></b-col>
                <b-col md="3">
                  <b-form-group label="IGV :" label-for="input-1">
                    <select
                      ref="igv"
                      disabled
                      v-model="product.igv"
                      class="form-control"
                    >
                      <option value="10">Gravado</option>   
                      <option value="20">Exonerado</option>
                      <option value="30">Inafecto</option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Stock :">
                    <b-form-input
                    disabled
                      type="number"
                      class="text-right"
                      ref="stock"
                      v-model="product.stock"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>

        

                <b-col md="3"></b-col>
                <b-col md="2">
                  <b-form-group label="Precio Minimo :">
                    <b-form-input
                    disabled
                      type="number"
                      class="text-right"
                      step="any"
                      ref="minimal_price"
                      v-model="product.minimal_price"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="Precio Real :">
                    <b-form-input
                    disabled
                      type="number"
                      class="text-right"
                      step="any"
                      ref="real_price"
                      v-model="product.real_price"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="Precio Venta :">
                    <b-form-input
                    disabled
                      type="number"
                      class="text-right"
                      step="any"
                      ref="sale_price"
                      v-model="product.sale_price"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>


                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-form-group label="Estado :" label-for="input-1">
                    <select
                    disabled
                      ref="state"
                      v-model="product.state"
                      class="form-control"
                    >
                      <option value="1">Activo</option>
                      <option value="0">Inactivo</option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col md="3"></b-col>

                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-link
                    class="btn form-control btn-primary"
                    :to="{ path: '/producto/listar' }"
                    append
                    >REGRESAR</b-link
                  >
                </b-col>
              </b-row>
            </b-form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";

export default {
  name: "ProductView",
   props: ["id_product"],
  data() {
    return {
      module:'Product',
      product: {
        id_product: "",
        id_category: "",
        code: "",
        name: "",
        short_name: "",
        description: "",
        existence_type: "",
        unit_measure: "",
        igv: "",
        stock: 0,
        photo: "",
        minimal_price: 0.00,
        real_price: 0.00,
        sale_price: 0.00,
        state: 1,
      },

      categories: [],
      //errors
      errors: {
        id_category: false,
        code: false,
        name: false,
        state: false,

      },
      validate: false,
    };
  },
  mounted() {
    this.ListCategories();
    this.ViewProduct();
  },
  methods: {
    ListCategories,
    ViewProduct,

  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};



function ListCategories() {
  let me = this;
  let url = this.url_base + "active-categories";

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.categories = response.data.result;
      } else {
        Swal.fire("404", "A Ocurrido un error", "error");
      }
    })
    .catch((error) => {
      Swal.fire("422", "A Ocurrido un error", "error");
    });
}

//ver usuario
function ViewProduct() {
  let id_product = je.decrypt(this.id_product);
  let me = this;
  let url = this.url_base + "product/view/" + id_product;

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
      module: this.module,
      role: 5,
    },
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.product.id_product = response.data.result.id_product;
        me.product.id_category = response.data.result.id_category;
        me.product.code = response.data.result.code;
        me.product.name = response.data.result.name;
        me.product.short_name = response.data.result.short_name;
        me.product.description = response.data.result.description;
        me.product.existence_type = response.data.result.existence_type;
        me.product.unit_measure = response.data.result.unit_measure;
        me.product.igv = response.data.result.igv;
        me.product.stock = response.data.result.stock;
        me.product.photo = response.data.result.photo;
        me.product.minimal_price = response.data.result.minimal_price;
        me.product.real_price = response.data.result.real_price;
        me.product.sale_price = response.data.result.sale_price;
        me.product.state = response.data.result.state;
      } else {
        Swal.fire("404", "A Ocurrido un error", "error");
      }
    })
    .catch((error) => {
      Swal.fire("422", "A Ocurrido un error", "error");
    });
}

</script>
